module.exports = __webpack_public_path__ + "img/288.0815ae37.jpg";